import React, { useState, useEffect } from 'react';

import './styles.css';

import Card from '../../../../components/Card';
import PopupNewProduct from './PopupNewProduct';
import PopupProduct from './PopupProduct';
import ProductsCardItem from './ProductsCardItem';
import ActivityIndicator from '../../../../components/ActivityIndicator';
import { FaCube, FaExclamationTriangle, FaFilter, FaPrint, FaTrash } from 'react-icons/fa';
import FilterProductsPopUp from './FilterProductsPopUp';
import reportServices from '../../../../services/reportServices';
import PopupReports from '../../../../components/PopupReports';
import { deleteProduct } from '../../../../services/admFin/productServices';

export default function ProductsCard(props) {
    const [products, setProducts] = useState([]);
    const [visibilityFilter, setVisibilityFilter] = useState(false);
    const [visibilityReport, setVisibilityReport] = useState(false);
    const [popupNewProductVisible, setPopupNewProductVisible] = useState(false);
    const [popupNewProductData, setPopupNewProductData] = useState({});
    const [popupProductVisible, setPopupProductVisible] = useState(false);
    const [popupProductData, setPopupProductData] = useState({});
    const [numShowed, setNumShowed] = useState(5);

    useEffect(() => {
        if (props.products) {
            if (!props.criticalMode)
                setProducts(props.products);
            else
                setProducts(props.products.filter(item => item.quantidade < item.quantidade_critica));

            if (popupProductData.id) setPopupProductData(props.products.find(item => item.id === popupProductData.id));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.products]);

    function onItemClick(product) {
        setPopupProductData(product);
        setPopupProductVisible(true);
    }

    function editProduct(product) {
        setPopupNewProductData(product);
        setPopupNewProductVisible(true);
    }

    function showMoreProducts() {
        if (props.products) {
            if (numShowed + 3 >= products.length)
                setNumShowed(products.length);
            else
                setNumShowed(numShowed + 3);
        }
    }

    function generateReport(fields = null, fileName) {
        console.log(fields);
        try {
            reportServices.generateReportStock(products, `RELATÓRIO DE ESTOQUE${props.criticalMode ? " CRÍTICO" : ""}`, fields, fileName);
            return true;
        } catch (err) {
            alert(err.message);
            return false;
        }
    }

    async function deleteElement(id) {
        // eslint-disable-next-line no-restricted-globals
        if(confirm("Deseja deletar este produto?")) {
            try {
                await deleteProduct(id);

                setProducts(oldArray => {
                    const temp = [...oldArray];
                    return temp.filter(obj => obj.id !== id);
                })
            } catch(err) {
                alert("Erro ao deletar cadastro");
            }
        }
    }

    return (
        <Card
            id="products-card"
            className="products-card"
            tittle={!props.criticalMode ? <><FaCube />Produtos</> : <><FaExclamationTriangle />Estoque crítico</>}
            options={
                <>
                    {
                        !props.criticalMode ?
                            <>
                                < button type='button' onClick={() => setVisibilityFilter(true)}><FaFilter /></button>
                                <FilterProductsPopUp
                                    products={props.products ? props.products : []}
                                    setProducts={setProducts}
                                    visibility={visibilityFilter}
                                    setVisibility={setVisibilityFilter}
                                />
                            </>
                            : []
                    }

                    <>
                        <button title='Relatório de Estoque' onClick={() => setVisibilityReport(true)}><FaPrint /></button>
                        <PopupReports
                            visibility={visibilityReport}
                            setVisibility={setVisibilityReport}
                            tittle="Relatório de Estoque"
                            fields={reportServices.stockFields}
                            generateReport={generateReport}
                        />
                    </>

                    <span className={"tag medium " + (!props.criticalMode ? "blue" : "red")}>
                        {
                            products && products.length ?
                                `${products.length} ${products.length === 1 ? "produto" : "produtos"}`
                                : "0 produtos"
                        }
                    </span>
                </>
            }
        >
            {
                !props.criticalMode && props.onCreate ?
                    <button
                        className="blue"
                        onClick={() => {
                            setPopupNewProductData({});
                            setPopupNewProductVisible(true);
                        }}
                    >
                        Adicionar produto
                    </button>
                    // O componente do popup de criação de produto está ao final do card para garantir a sobreposição dele ao card de visualização do produto
                    : []
            }

            {
                props.products ?
                    products.length ?
                        <>
                            <ul className='list'>
                                {
                                    products.slice(0, numShowed).map((item, index) =>
                                        <div className='product-item-container' key={index}>
                                            <div>
                                                <ProductsCardItem
                                                    key={item.id}
                                                    criticalMode={props.criticalMode}
                                                    tittle={item.nome}
                                                    code={item.id}
                                                    quantity={item.quantidade}
                                                    gap={item.quantidade_critica - item.quantidade}
                                                    onClick={() => onItemClick(item)}
                                                />

                                            </div>
                                            <button className="red" onClick={() => deleteElement(item.id)}>
                                                <FaTrash />
                                            </button>
                                        </div>
                                    )
                                }
                            </ul>
                            {
                                numShowed < products.length ?
                                    <button className='show-more' onClick={showMoreProducts}>Exibir mais</button>
                                    : []
                            }

                            <PopupProduct
                                visibility={popupProductVisible}
                                setVisibility={setPopupProductVisible}
                                data={popupProductData}
                                onUpdate={props.onUpdate}
                                editProduct={editProduct}
                            />
                        </>
                        : []
                    : <ActivityIndicator />
            }

            <PopupNewProduct
                visibility={popupNewProductVisible}
                setVisibility={setPopupNewProductVisible}
                data={popupNewProductData}
                criticalMode={props.criticalMode}
                onCreate={props.onCreate}
                onUpdate={props.onUpdate}
            />
        </Card >
    )
}